import { Button } from "@faire/slate/components/button";
import { useState } from "react";

import { ReportedProductCard } from "./ReportedProductCard";
import { RetailerMobileNav } from "./RetailerMobileNav";
import {
  BRAND_NAME,
  REPORTED_PRODUCTS,
  RETURN_BY_DATE_LONG,
  type ReportedProduct,
} from "./retailerReportIssueData";

type ReviewConfirmScreenProps = {
  onSubmit?: () => void;
  onEditResolution?: () => void;
};

export const ReviewConfirmScreen = ({
  onSubmit,
  onEditResolution,
}: ReviewConfirmScreenProps) => {
  const [products, setProducts] =
    useState<ReportedProduct[]>(REPORTED_PRODUCTS);

  const handleDelete = (productId: string) => {
    setProducts((current) =>
      current.filter((product) => product.id !== productId)
    );
  };

  return (
    <div className="bg-fs-surface-primary flex min-h-full flex-col">
      <RetailerMobileNav progressFraction={0.85} />
      <div className="flex flex-1 flex-col px-(--slate-spacing-section-medium) pt-(--slate-spacing-section-medium) pb-(--slate-spacing-section-large)">
        <h1 className="type-fs-page-heading text-fs-text-primary mb-(--slate-dimensions-6)">
          Review &amp; confirm
        </h1>

        <div className="flex flex-col gap-(--slate-spacing-group-section)">
          <div className="flex flex-col gap-(--slate-dimensions-1)">
            <span className="type-fs-paragraph-medium text-fs-text-primary">
              Resolution
            </span>
            <div className="flex items-center gap-(--slate-dimensions-2)">
              <span className="type-fs-paragraph text-fs-text-primary">
                Replace items
              </span>
              <button
                type="button"
                className="type-fs-paragraph text-fs-text-primary underline"
                onClick={onEditResolution}
              >
                Edit
              </button>
            </div>
          </div>

          <div className="flex flex-col gap-(--slate-dimensions-2)">
            <p className="type-fs-paragraph text-fs-text-primary pt-(--slate-dimensions-4) pb-(--slate-dimensions-4)">
              {BRAND_NAME} requests damaged items to be returned by{" "}
              {RETURN_BY_DATE_LONG}. Instructions and labels will be shown after
              report submission.
            </p>
          </div>

          <div className="flex flex-col gap-(--slate-dimensions-2)">
            <span className="type-fs-paragraph-medium text-fs-text-primary">
              Products
            </span>
            <div className="flex flex-col gap-(--slate-spacing-element-medium)">
              {products.map((product) => (
                <ReportedProductCard
                  key={product.id}
                  product={product}
                  showDelete
                  onDelete={() => handleDelete(product.id)}
                />
              ))}
              <Button variant="plain" size="small">
                Add more
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-fs-surface-primary sticky bottom-0 px-(--slate-spacing-section-medium) pt-(--slate-dimensions-2) pb-(--slate-spacing-section-medium)">
        <Button variant="primary" fullWidth onClick={onSubmit}>
          Submit
        </Button>
      </div>
    </div>
  );
};
